import { render, staticRenderFns } from "./favOrg.vue?vue&type=template&id=e67a3666"
import script from "./favOrg.vue?vue&type=script&lang=js"
export * from "./favOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports